// Step 2
// Personal user Details

import React, { useState, useEffect, useRef } from "react";
import ApiService from "../../services/api.service";
import InputFields from "../../common/input";
// import {
//   Phone,
//   Title,
//   Mail,
//   User
// } from '../../common/icons'

export default function SecondaryPersonalDetailsStep({
  languages,
  currentStep,
  taxNumberIN,
  locationData,
  inputSecondaryPersonalEl,
  stepNo,
  secondaryInputFields,
  secondaryPersonalDetailsSubmit,
  secondaryInputChange,
  secondaryInputPhoneChange,
  onFieldBlur,
  emailChecking,
}) {
  if (currentStep !== stepNo) {
    return null;
  }

  return (
    <div className="flex justify-evenly align-center tablet:mt-5 tablet:mx-10">
      <form
        id="secondary-personal-details"
        className="w-full tablet:px-10"
        onSubmit={secondaryPersonalDetailsSubmit}
      >
        {/* Personal Details */}
        <InputFields
          languages={languages}
          inputFields={secondaryInputFields}
          inputChange={secondaryInputChange}
          inputPhoneChange={secondaryInputPhoneChange}
          onFieldBlur={onFieldBlur}
          inputEl={inputSecondaryPersonalEl}
          locationData={locationData}
          taxNumberIN={taxNumberIN}
          emailChecking={emailChecking}
        />
      </form>
    </div>
  );
}
